import './SectionsTitle.scss';

const SectionsTitle = (props) => {
  return (
    <div className='title'>{props.title}</div>
  )
}

export default SectionsTitle